module.exports = __webpack_public_path__ + "12d2e303253d2dfd8055bdb1441ca198.png";